import router from '@/router'
import store from '@/store/'
import { getLocation } from '@/utils/route'

/**
 * @typedef {object} RouteParam
 * @property {string} name
 * @property {object} params
 */

export default {
  install(Vue) {
    /**
     * 案件IDを考慮した独自ルーター
     */
    Vue.prototype.$wcRouter = {
      /**
       * 画面遷移
       * @param {RouteParam} param
       */
      push({ name, params }) {
        const location = getLocation(store, router, name, params)
        router.push(location)
      },
      /**
       * 画面遷移（URL履歴を残さない）
       * @param {RouteParam} param
       */
      replace({ name, params }) {
        const location = getLocation(store, router, name, params)
        router.replace(location)
      },
      /**
       * パス取得
       * @param {RouteParam} param
       * @returns {string}
       */
      path({ name, params }) {
        const location = getLocation(store, router, name, params)
        const { href } = router.resolve(location)
        return href
      }
    }
  }
}
